import routes from 'agentRoutes';
import httpClient from 'agentHTTPClient';
import { taskStatus } from '../../../../admin/Orders/Show/helpers/constants';
import { fetchPostBookingActionStatus } from '../../../../admin/Orders/Show/AncillariesTab/SeatMapModal/helpers/api';

export const FETCHING_EXCHANGE_QUOTE = 'FETCHING_EXCHANGE_QUOTE';
function fetchingExchangeQuote(reservationItemIdentifier, resultId) {
  return {
    type: FETCHING_EXCHANGE_QUOTE,
    reservationItemIdentifier,
    resultId,
  };
}

export const EXCHANGE_QUOTE_FETCHED = 'EXCHANGE_QUOTE_FETCHED';
function exchangeQuoteFetched(reservationItemIdentifier, resultId, data) {
  return {
    type: EXCHANGE_QUOTE_FETCHED,
    reservationItemIdentifier,
    resultId,
    data,
  };
}

export const RESET_EXCHANGE_QUOTE_STATUS = 'RESET_EXCHANGE_QUOTE_STATUS';
export function resetExchangeQuoteStatus() {
  return {
    type: 'RESET_EXCHANGE_QUOTE_STATUS',
  };
}

export const EXCHANGE_QUOTE_FETCHING_FAILED = 'EXCHANGE_QUOTE_FETCHING_FAILED';
function exchangeQuoteFetchingFailed(reservationItemIdentifier, resultId) {
  return {
    type: EXCHANGE_QUOTE_FETCHING_FAILED,
    reservationItemIdentifier,
    resultId,
  };
}

export function fetchExchangeQuote(reservationItemIdentifier, resultId, unchangedTripIds) {
  return dispatch => {
    dispatch(fetchingExchangeQuote(reservationItemIdentifier, resultId));

    return httpClient
      .post(
        routes.api.flights.exchange.fetchQuote({
          id: resultId,
        }),
        {
          id: resultId,
          reservation_item_identifier: reservationItemIdentifier,
          unchanged_flights: unchangedTripIds,
        },
      )
      .then(({ data }) => {
        dispatch(exchangeQuoteFetched(reservationItemIdentifier, resultId, data));
        return true;
      })
      .catch(() => {
        dispatch(exchangeQuoteFetchingFailed(reservationItemIdentifier, resultId));
        return false;
      });
  };
}

export const CONFIRMING_EXCHANGE_QUOTE = 'CONFIRMING_EXCHANGE_QUOTE';
function confirmingExchangeQuote(reservationItemIdentifier, quoteId) {
  return {
    type: CONFIRMING_EXCHANGE_QUOTE,
    reservationItemIdentifier,
    quoteId,
  };
}

export const EXCHANGE_QUOTE_CONFIRMED = 'EXCHANGE_QUOTE_CONFIRMED';
function exchangeQuoteConfirmed(reservationItemIdentifier, quoteId) {
  return {
    type: EXCHANGE_QUOTE_CONFIRMED,
    reservationItemIdentifier,
    quoteId,
  };
}

export const EXCHANGE_QUOTE_CONFIRMATION_FAILED = 'EXCHANGE_QUOTE_CONFIRMATION_FAILED';
function exchangeQuoteConfirmationFailed(reservationItemIdentifier, quoteId) {
  return {
    type: EXCHANGE_QUOTE_CONFIRMATION_FAILED,
    reservationItemIdentifier,
    quoteId,
  };
}

const pollStatus = (itemId, id, delay) =>
  new Promise((resolve, reject) => {
    let timeoutId;

    const checkStatus = () => {
      fetchPostBookingActionStatus(itemId, id)
        .then(({ status }) => {
          if (timeoutId) {
            clearTimeout(timeoutId);
          }

          if (status === taskStatus.completed) {
            resolve();
          } else if (status === taskStatus.failed) {
            resolve();
          } else {
            timeoutId = setTimeout(checkStatus, delay);
          }
        })
        .catch(() => reject());
    };

    checkStatus();
  });

export function confirmExchangeQuote(reservationItemIdentifier, resultId, fop, itemId) {
  return (dispatch, getState) => {
    const quoteId = getState().flights.currentExchangeQuote.quoteId;
    const pollingInterval = 3000;

    dispatch(confirmingExchangeQuote(reservationItemIdentifier, quoteId));

    return httpClient
      .post(routes.api.flights.exchange.confirmExchange({ id: resultId }), {
        quote_id: quoteId,
        reservation_item_identifier: reservationItemIdentifier,
        execution_type: fop,
      })
      .then(({ data }) => pollStatus(itemId, data.id, pollingInterval))
      .then(() => {
        dispatch(exchangeQuoteConfirmed(reservationItemIdentifier, quoteId));
        return true;
      })
      .catch(() => {
        dispatch(exchangeQuoteConfirmationFailed(reservationItemIdentifier, quoteId));
        return false;
      });
  };
}
